/**
 * Generic pill toggle used by leaderboard variants. The POLF chip /
 * Stableford toggle and the BestBall team / individual toggle share this
 * single implementation — they only differ in the option list.
 */
const Toggle = <T extends string>({
  options,
  value,
  onChange,
}: {
  options: ReadonlyArray<{ value: T; label: string }>
  value: T
  onChange: (next: T) => void
}) => (
  <div
    role="tablist"
    className="inline-flex rounded-full bg-ink-100 p-1 text-xs font-bold uppercase tracking-wider"
  >
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        role="tab"
        aria-selected={value === o.value}
        onClick={() => onChange(o.value)}
        className={`px-3 py-1.5 rounded-full transition-colors ${
          value === o.value ? 'bg-paper text-ink-900 shadow' : 'text-ink-500'
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
)

export default Toggle
